import React, {Component} from 'react';
import {I18N, CONFIG} from '../../globals/config';
import AssignmentSearchResult from './search/assignment-search-result';
import Loading from '../loading';


class AssignmentSearchModal extends Component {
	constructor( props ){
		super( props );

		this.state = {
			items : [],
			search : "",
			initial : true
		}
	}

	render(){
		var $content = "";
		if( this.state.items.length === 0 ){
			if( this.state.initial ){
				$content = ( <Loading /> );
			} else {
				$content = (
					<div className="message">
						{I18N.no_matches_found}
					</div> );
			}
		} else {
			$content = (
				<ul>
					{this.state.items.map( function( post ){
						return (
							<AssignmentSearchResult Post={post} key={'post-result-' + post.id} form={this}/>
						)
					}.bind( this ) )}
				</ul>
			);
		}

		return (
			<div className="search-modal">
				<input name="search" value={this.state.search} onInput={this._update_results.bind( this )} placeholder={I18N.search}/>
				<div className="results-wrap">
					{$content}
				</div>
			</div>
		)
	}

	_update_results( ev ){
		this.setState( {
			search : ev.target.value,
			initial : false
		} );
		this._get_results( ev.target.value );
	}

	reset_search(){
		this.setState( {
			search : "",
			initial : true
		} );
		this._get_results( "" );
	}

	_get_results( $search ){
		var data            = {
			per_page : 10,
			search : $search,
			author : CONFIG.current_user_id,
			orderby : 'date',
			order : 'desc'
		};
		var postsCollection = new wp.api.collections.Assignment();
		postsCollection.fetch( {data : data} ).done( function( pages ){
			this.setState( {
				items : pages,
				initial : false
			} );
		}.bind( this ) );
	}

	componentWillMount(){
		this._get_results( this.state.search );
	}

}


export default AssignmentSearchModal;



// WEBPACK FOOTER //
// ./src/components/modals/assignment-search-modal.js